import { User } from './user.model';

export interface RequestLeaveApprover {
  id: number;
  approver: User;
  deleted: boolean;
}
